
export default {
  props: {
    text: ""
  },
  data() {
    return {
      showMore: false,
      showMoreButton: false
    };
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    }
  },
  mounted() {
    // Show more button if content exceeds 3 lines
    const content = this.$el.querySelector(".content");
    if (content.scrollHeight > content.clientHeight) {
      this.showMore = false;
      this.showMoreButton = true;
    }
  }
};
